import { api } from '../slices/api';
import { JawSet } from '../../interfaces/Fixtures.Interface';

// Define a service using a base URL and expected endpoints
export const extendedApiSlice = api.injectEndpoints({
	endpoints: (builder) => ({
		getJawSets: builder.query<JawSet[], void>({
			query: () => 'fixtures/jaws',
		}),
	}),
	overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetJawSetsQuery } = extendedApiSlice;
